import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { class: "submit-wrap" }

import { reactive, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { showFailToast } from 'vant';
  import { useAuthStore } from '@/store/auth';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

  const authStore = useAuthStore();
  const router = useRouter();
  const route = useRoute();
  const loading = ref(false);

  const form = reactive({
    username: '',
    password: '',
  });

  const onSubmit = async (): Promise<void> => {
    loading.value = true;

    try {
      await authStore.login({ username: form.username, password: form.password });
      const redirect = Array.isArray(route.query.redirect)
        ? route.query.redirect[0]
        : route.query.redirect;
      const targetPath = typeof redirect === 'string' && redirect.startsWith('/') ? redirect : '/';
      await router.replace(targetPath);
    } catch (error) {
      const message = error instanceof Error ? error.message : '登录失败';
      showFailToast(message);
    } finally {
      loading.value = false;
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "system-title" }, "餐厅系统", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            modelValue: form.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
            modelModifiers: { trim: true },
            name: "username",
            label: "账号",
            placeholder: "请输入账号",
            rules: [{ required: true, message: '请输入账号' }]
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
            type: "password",
            name: "password",
            label: "密码",
            placeholder: "请输入密码",
            rules: [{ required: true, message: '请输入密码' }]
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              block: "",
              round: "",
              type: "primary",
              "native-type": "submit",
              loading: loading.value
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("登录", -1)
              ])),
              _: 1,
              __: [2]
            }, 8, ["loading"])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "sub-title" }, "请使用公司员工账号登录", -1))
        ]),
        _: 1,
        __: [3]
      })
    ])
  ]))
}
}

})